import { RootState } from 'editor/src/store/index';

const getRequestedVersion = (state: RootState) => state.editorModules.addons.requestedVersion;

export default getRequestedVersion;
